import type { PreloadedQuery } from 'react-relay';
import { createAri } from '@jira/platform__utils-ari/src/index.tsx';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import QUERY, {
	type CardCoverPageContentQuery,
} from './__generated__/CardCoverPageContentQuery.graphql';

const RESOURCE_TYPE_BOARD_CONTEXT_CARD_COVER_SETTINGS = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';

export const cardCoverImageResource: RouteResource<
	PreloadedQuery<CardCoverPageContentQuery, Record<string, unknown>>
> = createRelayResource<CardCoverPageContentQuery>({
	type: RESOURCE_TYPE_BOARD_CONTEXT_CARD_COVER_SETTINGS,
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: QUERY,
		variables: {
			boardId: createAri({
				resourceOwner: 'jira-software',
				cloudId: tenantContext.cloudId,
				resourceType: 'board',
				resourceId: String(match.params.boardId),
			}),
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
